<template>
  <v-overlay v-bind="$attrs" :value="show">
    <v-progress-circular
        color="primary"
        indeterminate
        size="64"
    />
  </v-overlay>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: false
  }),
  watch: {
    isLoading: {
      immediate: true,
      handler (nV) {
        this.show = nV
      }
    }
  }
}
</script>
